import styled from 'styled-components'

export const SecondaryCategoryRowStyled = styled.button<{
  $isActive: boolean
  $isDimmed: boolean
}>`
  display: block;
  width: 100%;
  padding: ${(props) => props.theme.typography.pxToRem(12)}
    ${(props) => props.theme.typography.pxToRem(16)};
  border: none;
  border-bottom: 1px solid
    ${(props) => props.theme.colors.content.secondaryBorder};
  text-align: left;
  cursor: pointer;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: ${(props) =>
    props.$isActive
      ? props.theme.fontWeights.bold
      : props.theme.fontWeights.normal};
  background-color: ${(props) =>
    props.$isActive ? props.theme.colors.selected : props.theme.colors.white};
  color: ${(props) => props.theme.colors.text.primary};
  opacity: ${(props) => (props.$isDimmed ? 0.5 : 1)};

  &:hover {
    background-color: ${(props) =>
      props.$isActive
        ? props.theme.colors.selected
        : props.theme.colors.form.select.optionBackgroundHover};
  }
`
